module.exports = __webpack_public_path__ + "img/FRSIS_POSTER2.c39b5634.png";